import React from 'react';
import {NavLink} from 'react-router-dom';
import MotifButton from '@ey/motif-react-wrapper/Button';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import {
	IconoirHome,
	IconoirCustomListStack,
	IconoirClock	
} from '@ey-xd/motif-icon';
import {IconoirCustomServiceGateway} from '@ey/motif-react-wrapper/assets/icons/custom';
import {labels} from '../../../util/uiconstants';
import _ from 'lodash';
import { clickActionArgs } from '../../Common/Adobe Analytics/actionHelpers.js';
import { eventTypes, controlTypes, locationInPages, clickActionNames, webInteractionTypes } from '../../Common/Adobe Analytics/constants.js';

export function MenuIconOptions(featureConfigurations, isGuestUser, trackEvent) {
	let menuOptions = [];

	const isTimeTrackingEnabled = featureConfigurations.istimetrackingenabled;
	const isServiceGatewayBaseUri = !_.isEmpty(
		featureConfigurations.servicegatewaybaseuri
	);
	const serviceGatewayBaseUri = featureConfigurations.servicegatewaybaseuri;

	const showArchive = () => {
		if (isGuestUser === undefined || isGuestUser) {
			return false;
		} else {
			return true;
		}
	};

	// Adobe Analytics Click Tracking
	const trackAdobeAnalyticsClickAction = (clickActionName) =>
	{
		let webInteractionUrl = `${window.location.origin}/`;
		switch (clickActionName) {
			case clickActionNames.archives:
				webInteractionUrl += 'archives';
				break;
			case clickActionNames.timeTracker:
				webInteractionUrl += 'timesheet';
				break;
			case clickActionNames.eyServiceGateway:
				webInteractionUrl = serviceGatewayBaseUri;
				break;
		}

		trackEvent(
			eventTypes.clickAction,
			clickActionArgs(
				clickActionName,
				controlTypes.icon,
				locationInPages.menu,
				webInteractionUrl,
				clickActionName === clickActionNames.eyServiceGateway ? webInteractionTypes.exit : webInteractionTypes.other
			));
	};

	menuOptions.push(
		{
			key: 'LandingPage',
			className: 'LandingPage',
			isLink: false,
			children: (
				<MotifButton
					aria-label="Click to go to dashboard"
					type="button"
					variant="ghost"
					size="medium"
					title={labels.engagements}
					className="motif-button-icon-only"
				>
					<NavLink to={'/'} title={labels.engagements}
							 onClick={() => { trackAdobeAnalyticsClickAction(clickActionNames.engagements) }}>
						<MotifIcon
							src={IconoirHome}
							size="24"
							title={labels.engagements}
						/>
					</NavLink>
				</MotifButton>
			)
		}
	);

	if (showArchive()) {
		menuOptions.push({
			key: 'topNavEyUserArchives',
			isLink: false,
			children: (
				<MotifButton
					aria-label="Click to go to archives"
					type="button"
					variant="ghost"
					size="medium"
					title={labels.archives}
					className="motif-button-icon-only"
				>
					<NavLink to="/archives"
							 onClick={() => { trackAdobeAnalyticsClickAction(clickActionNames.archives) }}>
						<MotifIcon
							src={IconoirCustomListStack}
							className="archives-icon"
							size="24"
							title={labels.archives}
						/>
					</NavLink>
				</MotifButton>
			)
		});
	}

	if (!isGuestUser && isTimeTrackingEnabled) {
		menuOptions.push({
			key: 'topNavEyUserTimeTracking',
			isLink: false,
			children: (
				<MotifButton
					aria-label="Click to go to time tracking"
					type="button"
					variant="ghost"
					size="medium"
					title={labels.timeTracking}
					className="motif-button-icon-only"
				>
					<NavLink to="/timesheet" 
							 title={labels.timeTracking}
						     onClick={() => { trackAdobeAnalyticsClickAction(clickActionNames.timeTracker) }}>
						<MotifIcon
							src={IconoirClock}
							size="24"
							title={labels.timeTracking}
						/>
					</NavLink>
				</MotifButton>
			)
		});
	}

	if (!isGuestUser && isServiceGatewayBaseUri) {
		menuOptions.push({
			key: 'topNavEyUserServiceGateway',
			isLink: false,
			children: (
				<MotifButton
					aria-label="Click to go to service gateway"
					type="button"
					variant="ghost"
					size="medium"
					title={labels.serviceGateway}
					className="motif-button-icon-only"
				>
					<a href={serviceGatewayBaseUri} title={labels.serviceGateway} 
						onClick={() => { trackAdobeAnalyticsClickAction(clickActionNames.eyServiceGateway) }}>
						<MotifIcon
							iconFunction={IconoirCustomServiceGateway}
							size="24"
							title={labels.serviceGateway}
						/>
					</a>
				</MotifButton>
			)
		});
	}

	return menuOptions;
}
